import {
  type OpportunitiesSearchFilters,
  ProjectFilterDefault,
} from "@repo/api";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";

export const hasActiveFilters = (filters: OpportunitiesSearchFilters) => {
  const activeFilters = omit(filters, [
    "coworkerFilter",
    "teamFilter",
    "assignedToTeam",
  ]);

  const defaultFilters = omit(ProjectFilterDefault, [
    "coworkerFilter",
    "teamFilter",
    "assignedToTeam",
  ]);

  return !isEqual(activeFilters, defaultFilters);
};
